<div class="preference">
  <div class="preference__avatar">
    <div class="preference__avatar-wrapper">
      @if (
        userData.profileImageUrl !== null && !tmpAvatar) {
        <img
          class="image"
          [src]="apiBase + userData.profileImageUrl | secure | async"
          alt=""
          />
      } @else {
        <img class="image" [src]="tmpAvatar" />
      }

      <div class="preference__edit-avatar" (click)="imageInput.click()">
        <mat-icon>edit</mat-icon>
      </div>
      <input
        #imageInput
        hidden="true"
        type="file"
        onclick="this.value=null"
        (change)="updateUserProfileImage(imageInput.files!)"
        accept=".jpg,.png"
        />
    </div>
  </div>

  <form class="form-setting" [formGroup]="formData">
    <div>
      <mat-form-field appearance="outline" color="primary" class="dialog-input">
        <mat-label>Name</mat-label>
        <input matInput formControlName="name" />
        @if (formData.get('name')?.hasError('required')) {
          <mat-error
            >Name is required</mat-error
            >
          }
        </mat-form-field>

        <mat-form-field appearance="outline" color="primary" class="dialog-input">
          <mat-label>Email Address</mat-label>
          <input matInput formControlName="email" />
        </mat-form-field>

        @if (authService.hasPermission(Permission.UsersFull)) {
          <mat-form-field
            appearance="outline"
            color="primary"
            class="dialog-input"
            >
            <mat-label>User Group</mat-label>
            <mat-select formControlName="group" multiple>
              @for (group of groupList; track group) {
                <mat-option [value]="group.value">{{
                  group.text
                }}</mat-option>
              }
            </mat-select>
            @if (formData.get('group')?.hasError('required')) {
              <mat-error
                >User Group is required</mat-error
                >
              }
            </mat-form-field>
          }
        </div>

        <div>
          <div class="preference__label">
            <mat-icon>schedule</mat-icon>
            <span>Preference settings</span>
          </div>
          <mat-form-field appearance="outline" color="primary" class="dialog-input">
            <mat-label>Timezone</mat-label>

            <input
              type="text"
              matInput
              formControlName="timezone"
              [matAutocomplete]="auto"
              (keyup)="onKey($event)"
              />
            <mat-autocomplete #auto="matAutocomplete">
              @for (tz of timezoneListFiltered; track tz) {
                <mat-option
                  [value]="tz.text"
                  >{{ tz.text }}</mat-option
                  >
                }
              </mat-autocomplete>
            </mat-form-field>
            <div class="inline-row">
              <div class="flex-grow-1">
                <mat-form-field
                  appearance="outline"
                  color="primary"
                  class="dialog-input"
                  >
                  <mat-label>DateTime Format</mat-label>
                  <mat-select formControlName="dateFormat">
                    @for (el of dateTimeFormat; track el) {
                      <mat-option
                        [value]="el.value"
                        >{{ el.text }}</mat-option
                        >
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="full-row">
                  <mat-checkbox
                    class="example-margin"
                    formControlName="is24H"
                    color="primary"
                    >
                    24 hours time
                  </mat-checkbox>
                </div>
              </div>
              <div>
                <mat-radio-group
                  aria-label="Select an option"
                  formControlName="asAgo"
                  color="primary"
                  >
                  <mat-radio-button [value]="true">Days ago</mat-radio-button>
                  <mat-radio-button [value]="false">Date/Time</mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
          </form>

          <mat-dialog-actions align="end">
            <button mat-stroked-button mat-dialog-close>Cancel</button>
            <button
              mat-button
              [disabled]="loading"
              (click)="onSave()"
              color="buttonSuccess"
              >
              Save
            </button>
          </mat-dialog-actions>
        </div>
